
// ** React Imports
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

const VerticalLayout = props => {
  const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  useEffect(() => {
    import('@src/navigation/vertical').then(navigation => {
      setMenuData(navigation.default)
    })
  }, [])

  return (
    <Layout menuData={menuData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
